"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var PostViewContentTypes_1 = require("../../../../constants/PostViewContentTypes");
var react_redux_1 = require("react-redux");
var globalSlice_1 = require("../../../../features/global/globalSlice");
var styles_module_scss_1 = __importDefault(require("../../PersonalPostContent/PersonalPostViewNavigation/styles.module.scss"));
var DeveloperPostViewNavigation = function (_a) {
    var _b, _c, _d, _e;
    var handleSelectTab = _a.handleSelectTab, currentTab = _a.currentTab, hasAvailablePost = _a.hasAvailablePost, propertyType = _a.propertyType, isRent = _a.isRent;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var isMortgageCalcIconClicked = react_redux_1.useSelector(globalSlice_1.getIsMortgageCalcIconClicked);
    react_1.useEffect(function () {
        if (isMortgageCalcIconClicked) {
            handleSelectTab(PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO);
            dispatch(globalSlice_1.setIsMortgageCalcIconClicked(false));
        }
        if (currentTab !== PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO) {
            dispatch(globalSlice_1.setIsMortgageCalcIconClicked(false));
        }
    }, [isMortgageCalcIconClicked, currentTab]);
    return (react_1.default.createElement("div", { className: classnames_1.default('section-nav', styles_module_scss_1.default.navigation_section) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.navigation_box },
            react_1.default.createElement("button", { className: classnames_1.default('mini ui button', styles_module_scss_1.default.navigation_item, (_b = {},
                    _b[styles_module_scss_1.default.active] = currentTab === PostViewContentTypes_1.SECTION_TYPES.DEVELOPER_INFO,
                    _b)), onClick: function () {
                    return handleSelectTab(PostViewContentTypes_1.SECTION_TYPES.DEVELOPER_INFO);
                } }, t('POST_PREVIEW.DEVELOPER_INFO')),
            react_1.default.createElement("button", { className: classnames_1.default('mini ui button', styles_module_scss_1.default.navigation_item, (_c = {},
                    _c[styles_module_scss_1.default.active] = currentTab === PostViewContentTypes_1.SECTION_TYPES.BUILDING_INFO,
                    _c)), onClick: function () { return handleSelectTab(PostViewContentTypes_1.SECTION_TYPES.BUILDING_INFO); } }, t('POST_PREVIEW.BUILDING_INFO')),
            react_1.default.createElement("button", { className: classnames_1.default('mini ui button', styles_module_scss_1.default.navigation_item, (_d = {},
                    _d[styles_module_scss_1.default.active] = currentTab === PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO,
                    _d)), onClick: function () {
                    return handleSelectTab(PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO);
                } }, propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                ? t('POST_PREVIEW.HOUSES_INFO')
                : propertyType === PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
                    ? t('POST_PREVIEW.APARTMENTS_INFO')
                    : propertyType === PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                        ? t('POST_PREVIEW.COMMERCIALS_INFO')
                        : t('POST_PREVIEW.APARTMENTS_INFO'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bottom_section }, hasAvailablePost &&
            propertyType !== PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO &&
            !isRent && (react_1.default.createElement("div", null,
            react_1.default.createElement("button", { className: classnames_1.default('mini ui button', styles_module_scss_1.default.mortgage_button, (_e = {},
                    _e[styles_module_scss_1.default.active] = currentTab ===
                        PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO,
                    _e)), onClick: function () {
                    return handleSelectTab(PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO);
                } }, t('MORTGAGE_BUTTON.SECONDARY_TEXT')))))));
};
exports.default = DeveloperPostViewNavigation;
